var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-data"},[_c('img',{staticClass:"empty-image",attrs:{"src":require("@/assets/images/empty.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }